import { request } from "../index";

export function getProduct(id) {
  return request({ url: `products/${id}/` });
}
export function createProduct(data = {}) {
  return request({ url: "products/", data, method: "POST" });
}
export function updateProduct(data = {}) {
  return request({ url: `products/${data.id}/`, data, method: "PUT" });
}
export function deactivate(id) {
  return request({ url: `products/${id}/active/`, method: "DELETE" });
}
export function searchNCM(params = {}) {
  return request({ url: "products/ncm/", params });
}
export function searchCFOP(params = {}) {
  return request({ url: "products/cfop/", params });
}
export function searchBarcode(barcode) {
  return request({ url: `products/search_barcode/`, params: { barcode } });
}
export function searchProducts(params = {}) {
  return request({ url: "products/", params });
}
export function getMaxCode() {
  return request({ url: "products/max-code/" });
}
export function getCategories() {
  const data = {
    url: "products/categories/",
  };
  return request(data);
}
export function getUnits() {
  return request({ url: "products/units/" });
}
export function getUnit(id) {
  return request({ url: `products/units/${id}/` });
}
export function createUnit(data) {
  return request({ url: "products/units/", method: "POST", data });
}
export function createCategory(data) {
  return request({ url: "products/categories/", method: "POST", data });
}
export function updateCategory(name, id) {
  const data = {
    url: `products/categories/${id}/`,
    data: { name },
    method: "PUT",
  };
  return request(data);
}
export function getSuppliers() {
  const data = {
    url: "suppliers/",
  };
  return request(data);
}
export function getICMSList() {
  const data = {
    url: "icms/",
  };
  return request(data);
}
export function createICMSTemplate(templateData) {
  const data = {
    url: "icms/",
    data: templateData,
    method: "POST",
  };
  return request(data);
}
export function updateICMSTemplate(templateData) {
  const data = {
    url: `icms/${templateData.id}/`,
    data: templateData,
    method: "PUT",
  };
  return request(data);
}
export function calculateIBPT(products) {
  const data = {
    url: "products/get-ibpt-tax/",
    method: "POST",
    data: products,
  };
  return request(data);
}
export function importNFEData(data, type) {
  const formData = new FormData();
  formData.append("file", data, data.name);
  return request({
    url: `products/import-from/?type=${type}`,
    method: "POST",
    data: formData,
  });
}
export function finalizeImport(data, type) {
  return request({
    url: `products/import-from/?type=${type}`,
    method: "POST",
    data,
  });
}

export function validateProductRefCode(code) {
  return request({
    url: `products/validate-ref-code/`,
    method: "GET",
    params: { code },
  });
}



// WEBPACK FOOTER //
// ./src/api/products/index.js